import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { autocompleteFilter } from 'src/app/shared/helpers/autocompleteFilter.helper';
import { AuditSearchFilters } from 'src/app/shared/models/audit.model';
import { Posizione } from 'src/app/shared/models/posizione.model';

@Component({
  selector: 'app-audit-filters',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div class="card card-w-title">
    <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
      <h1>Ricerca Audit</h1>
      <div class="card formgrid grid">
        <div class="field col-3">
          <label for="descrizioneEvento">Descrizione evento o protocollo</label>
          <input pInputText type="text" id="descrizioneEvento" placeholder="" formControlName="descrizioneEvento" class="w-full" title="Descrizione evento" (keyup.enter)="doSearch()">
        </div>
        <div class="field col-2">
          <label for="dataEvento">Data evento</label>
          <p-calendar inputId="dataEvento" formControlName="dataEvento" [selectOtherMonths]="true" [dateFormat]="'dd/mm/yy'"
            [showIcon]="true" (keyup.enter)="doSearch()" styleClass="w-full"></p-calendar>
        </div>
        <div class="field col-2">
          <label for="userName">Username</label>
          <input pInputText type="text" id="userName" placeholder="" formControlName="userName" class="w-full" title="Username" (keyup.enter)="doSearch()">
        </div>
        <div class="field col-4">
          <label for="posizione">Fascicolo</label>
          <p-autoComplete inputId="posizione" formControlName="posizione" [suggestions]="posizioniFiltrate" [delay]="20" [size]="50"
            (completeMethod)="posizioniFiltrate = autocompleteFilter($event, posizioni(), 'sigla')" [dropdown]="true"
            dataKey="posizioneId" [forceSelection]="true" field="sigla" [autoHighlight]="true"
            [inputStyle]="{ 'width': '-webkit-fill-available' }" [autofocus]="true" >
          </p-autoComplete>
        </div>
        <div class="field col-1">
          <button pButton type="button" label="Cerca" (click)="doSearch()" [disabled]="!searchForm.valid"
            title="Cerca"></button>
          <button pButton type="button" label="Reset" (click)="searchForm.reset()" title="Reimposta"></button>
        </div>
      </div>
    </form>
  </div>
`,
  styles: [`
  :host ::ng-deep div.p-autocomplete.p-component { width: -webkit-fill-available; }
  button { margin-top: 1.85rem; margin-left: 0.3rem; }
`]
})
export class AuditFiltersComponent {
  posizioni = input<Posizione[] | null>(null);
  updateFiltersAndSearch = output<AuditSearchFilters>();

  private fb = inject(FormBuilder);

  public posizioniFiltrate: Posizione[] = [];
  public autocompleteFilter = autocompleteFilter;
  public searchForm = this.fb.group({
    eventId: this.fb.control<number | null>(null),
    dataEvento: this.fb.control<Date | null>(null),
    descrizioneEvento: this.fb.control<string | null>(null),
    posizione: this.fb.control<Posizione | null>(null),
    userName: this.fb.control<string | null>(null)
  });

  constructor() {
    effect(() => {
      this.posizioni()?.forEach(p => p.sigla = `${p.sigla} - ${p.descrizione}`);
      this.posizioniFiltrate = this.posizioni() ?? [];
    });
  }

  public doSearch(): void {
    const eventFilters: AuditSearchFilters = {
      eventId: this.searchForm.controls.eventId.value,
      dataEvento: this.searchForm.controls.dataEvento.value,
      descrizioneEvento: this.searchForm.controls.descrizioneEvento.value,
      posizioneId: this.searchForm.controls.posizione?.value?.posizioneId ?? null,
      userName: this.searchForm.controls.userName.value
    };

    this.updateFiltersAndSearch.emit(eventFilters);
  }
}

